


import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import MapObject from '@/interfaces/entities/map-object.interface';
import ApiService from '@/services/api.service';
import {ClientDeviceType} from '@/library/client-device/client-device-type';
import MapFeaturesService from '@/services/map-features.service';

@Component({})
export default class AppMapObjectActions extends Vue {

  @Prop()
  object!: MapObject;

  @Watch('object', {immediate: true, deep: true})
  public objectChange(): void {
    setTimeout(() => {
      this.isMarked = this.object.myFavorite;
    });
  }

  public isMarked: boolean = false;
  private apiService: ApiService = ApiService.getInstance();
  private mapFeaturesService: MapFeaturesService = MapFeaturesService.getInstance();

  constructor() {
    super();
  }

  public favorite(): string {
    return '{"type":"map-object","id":' + this.object.id + '}'
  }

  public toggleFavorite(): void {
    if (!this.apiService.user().isAuthenticated) {
      return;
    }
    this.object.myFavorite = !this.object.myFavorite;
    this.apiService.toggleMyFavorite(this.object.id, this.object.myFavorite);
  }

  public isAnyButtonAvailable(): boolean {
    return this.showAddToFavoritesButton() || this.showNavigateGpsButton();
  }

  public showAddToFavoritesButton(): boolean {
    return this.mapFeaturesService.isFeatureInFeaturesList(this.object.mapFeature.getId());
  }

  public showNavigateGpsButton(): boolean {
    return ClientDeviceType.isMobileOrTablet();
  }

  public openGpsNavigation(): void {
    const coordinates = this.coordinates();
    let url: string;
    if (ClientDeviceType.isIOS()) {
      url = 'https://maps.apple.com/?daddr=' + coordinates.lat + ',' + coordinates.long;
    } else {
      url = 'https://maps.google.com/?daddr=' + coordinates.lat + ',' + coordinates.long;
    }
    window.open(url, '_blank');
  }

  private coordinates(): { lat: number, long: number } {
    return {
      lat: this.object.mapFeature.values_.WGS84[1],
      long: this.object.mapFeature.values_.WGS84[0]
    };
  }
}
